import { render, staticRenderFns } from "./SchoolStructure.vue?vue&type=template&id=730d2cac&scoped=true&"
import script from "./SchoolStructure.vue?vue&type=script&lang=js&"
export * from "./SchoolStructure.vue?vue&type=script&lang=js&"
import style0 from "./SchoolStructure.vue?vue&type=style&index=0&id=730d2cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730d2cac",
  null
  
)

export default component.exports